import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('like-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.562 8.467A6.514 6.514 0 0 1 26.32 5h1.975a3.552 3.552 0 0 1 3.14 5.213L27.35 17.93h9.697a6.514 6.514 0 0 1 6.403 7.716l-2.923 15.584A2.171 2.171 0 0 1 38.394 43H14.25V20.397l6.313-11.93zM8.82 20.2h5.429V43h-5.43a3.257 3.257 0 0 1-3.257-3.257V23.457A3.257 3.257 0 0 1 8.82 20.2z"
  })));
});